import Badge from 'react-bootstrap/Badge';
import { FormInputDisplay } from 'Components/Forms/FormInputDisplay.js';
import { Row, Card, Col, Form, Button } from "react-bootstrap";
import { useEffect, useReducer, useState, useRef } from "react";
import { TextButton, IconTextButton, IconButton } from 'Components/Button';
import ErrorIcon from '@mui/icons-material/ErrorOutlined';
import Stack from 'react-bootstrap/Stack';
import { useParams, useLocation, useNavigate } from 'react-router-dom';
import { getEditOrgData, submitEditOrganizationData } from 'Components/Datatable/OrgAxiosFuncs'
import { ACTIONS, formInfoReducer } from 'Containers/Private/Organization/OrganizationFormDataReducer'
import { STATUSES, ERROR_MESSAGES } from "Utils/constants";
import { useDispatch } from "react-redux"
import { setStatus, setPopup, setRedirect } from "../../../../Store/ErrorInfoSlice";
import { setGlobalSuccessStatus, setGlobalErrorStatus } from 'Components/StatusHandling';

import { Link } from 'react-router-dom';
import { http } from "Utils/http";
import { store } from 'Store';
import { textInputDataReducer } from 'Components/Forms/FormReducers/TextInputReducer';
import DatatableBase from 'Components/Datatable/DatatableBase'
import { GetTextInputData, GetCheckboxInputData, GetDateInputData, GetPhoneInputData, GetSelectInputData, GetRadioInputData } from 'Containers/Private/Organization/Data files/OrganizationFields';
import { GetUserTextInputData, GetUserCheckboxInputData, GetUserDateInputData, GetUserPhoneInputData, GetUserSelectInputData, GetUserRadioInputData } from 'Containers/Private/Organization/Data files/UserFields';
import { Datatable_Column } from "Components/Datatable/DatatableComponents/DatatableColumn";
import { isInObject } from "Utils/utilityFunctions";

const nameConverter = {
    "orgName": "orgName",
    "psoId": "orgId",
    "orgURL": "orgURL",
    "orgAddrLine1": "orgAddr1",
    "orgAddrLine2": "orgAddr2",
    "orgCity": "orgCity",
    "orgStateCode": "orgState",
    "orgZip": "orgZip",
    "orgZipExt": "orgZipExt",
    "orgPhone": "orgPhone",
    "orgPhoneExtension": "orgPhoneExt",
    "orgFax": "orgFax",
    "organizationStatusId": "orgStatus",
    "scpEnroll": "orgIsSCPEnrolled",
    "scpEnrollDate": "orgSCPEnrollDate",
    "testOrg": "orgIsTest",

    "agreementEffectiveDate": "agreementEffectiveDate",
    "listingDate": "listingEffectiveDate",
    "agreementEndDate": "agreementEndDate",
    "listingEndDate": "listingEndDate",
    "password": "password"

}




function ViewOrganization () {
    let location = useLocation();
    const navigate = useNavigate();
    var passedData = location.state;
    //console.log("PASSED DATA");
    //console.log(passedData);
    let { oT } = useParams();
    const dispatch = useDispatch();
    const [viewUsersSortColumn, setViewUsersSortColumn] = useState({
        sortField: "firstName",
        sortDirection: "asc"
    });

    const [allowUserEdit, setAllowUserEdit] = useState(false);
    const [isPSOPPCAdmin, setIsPSOPPCAdmin] = useState(false);
    const [orgTypeId, setOrgTypeId] = useState(-1);

    const [filter, setFilter] = useState(null);
    const [orgType, setOrgType] = useState(passedData.orgType);
    const [orgId, setOrgId] = useState(passedData.id);


    useEffect(() => {
        
        //console.log("FILTER");
        //console.log(filter);
        //console.log(location);

        if (isInObject("filter", passedData)) {
            //console.log("setFilter");
            setFilter(passedData.filter);
        }
        else {
            setFilter({
                startIndex: 0,
                entryPerPage: 10,
                sortingColumn: viewUsersSortColumn.sortField,
                sortingOrder: viewUsersSortColumn.sortDirection,
                searchTerm: ""
            });
        }
        //console.log(filter);
    }, [])

    //    window.history.replaceState(DEFAULT_STATE_VALUE, '');

    const [isLoading, setIsLoading] = useState(true);
    //const orgType = passedData.orgType; //getOrgTypeText(oT);
    //const orgId = passedData.id;
    const [additionalOrganizationInfo, setAdditionalOrganizationInfo] = useState(null);
    const loginState = store.getState().loginInfo;

    


    useEffect(()=>{
        //console.log(orgType + ":" + orgId);
        //console.log(passedData);
    },[orgType, orgId])

    const setInitialData = (dispatch, value) => {
        //console.log("setinitialdata", value);
        dispatch({
            type: ACTIONS.SET_INITIAL_DATA,
            value: value
        })
    }

    const setInitialSelectData = (dispatch, options) => {
        //console.log("setinitialselectdata", options);

        dispatch({
            type: ACTIONS.SET_INITIAL_DATA,
            options: options
        })
    }

    const setInitialRadioData = (dispatch, radioButtons) => {
        //console.log("setinitialradiodata", radioButtons);

        dispatch({
            type: ACTIONS.SET_INITIAL_DATA,
            radioButtons: radioButtons
        })
    }

    const setDateFormat = (value) => {
        if (value != null) {
            var split = value.split('/');
            //console.log(split);
            if (split.length == 3) {
                return split[2] + '-' + split[0] + '-' + split[1];
            }
            return value;
        }
        return "";
    }

    const getOrgData = async (orgType, orgId) => {
        /*formInfoDispatch({
            type: ACTIONS.SET_INITIAL_DATA,
            data: '',
            loading: true
        })
        */
        // var orgType = passedData.orgType;

        var call = {
            orgDetails: {
                organizationId: orgId
            }
        }
        //console.log("CALL");
        //console.log(call);
        var url = '/api/manage/' + orgType + '/viewOrganizationDetail';
        var status = STATUSES.SUCCESS;

        //const response = PSOORGDATA;
        await http.post(url, call, {
            headers: {
                "Authorization": "Bearer " + loginState.token

            }
        }
        ).then((response) => {
            if (response.data != null) {
                setAllowUserEdit(response.data.allow_user_edit);
                setIsPSOPPCAdmin(response.data.isPSOPPCAdmin);
                if ('orgDetails' in response.data && 'userInfo' in response.data) {
                    setOrgTypeId(response.data.orgDetails.organizationTypeId);
                    setInitialData(orgNameInputDispatch, response.data.orgDetails.name);
                    setInitialData(orgPsoIdInputDispatch, response.data.orgDetails.psoId);
                    setInitialData(orgWebsiteInputDispatch, response.data.orgDetails.website);
                    setInitialData(orgAddress1InputDispatch, response.data.orgDetails.address1);
                    setInitialData(orgAddress2InputDispatch, response.data.orgDetails.address2);
                    setInitialData(orgCityInputDispatch, response.data.orgDetails.city);
                    setInitialSelectData(orgStateInputDispatch, stateListValues(response.data.demographics, response.data.orgDetails.regionId));
                    setInitialData(orgZipInputDispatch, response.data.orgDetails.zip);
                    setInitialData(orgZipExtensionInputDispatch, response.data.orgDetails.zipExtension);
                    setInitialData(orgPhoneInputDispatch, response.data.orgDetails.phone);
                    setInitialData(orgPhoneExtensionInputDispatch, response.data.orgDetails.extension);
                    setInitialData(orgFaxInputDispatch, response.data.orgDetails.fax);
                    setInitialRadioData(orgStatusIdInputDispatch, orgStatusValues(orgStatusId, response.data.organizationStatuses, response.data.orgDetails.statusId));
                    setInitialRadioData(orgTestOrgInputDispatch, orgTestValues(orgTestOrg, response.data.orgDetails.testOrg));
                    setInitialData(orgAgreementEffectiveDateInputDispatch, setDateFormat(response.data.orgDetails.agreementEffectiveDate));
                    setInitialData(orgListingEffectiveDateInputDispatch, setDateFormat(response.data.orgDetails.listingEffectiveDate));
                    setInitialData(orgAgreementEndDateInputDispatch, setDateFormat(response.data.orgDetails.agreementEndDate));
                    setInitialData(orgListingEndDateInputDispatch, setDateFormat(response.data.orgDetails.listingEndDate));

                    setInitialData(userFirstNameInputDispatch, response.data.userInfo.firstname);
                    setInitialData(userMiddleNameInputDispatch, response.data.userInfo.middlename);
                    setInitialData(userLastNameInputDispatch, response.data.userInfo.lastname);
                    setInitialSelectData(userPrefixInputDispatch, prefixListValues(response.data.prefixList, response.data.userInfo.prefix));
                    setInitialSelectData(userSuffixInputDispatch, suffixListValues(response.data.suffixList, response.data.userInfo.suffix));
                    setInitialData(userCredentialsInputDispatch, response.data.userInfo.credentials);
                    setInitialData(userJobTitleInputDispatch, response.data.userInfo.jobTitle);
                    setInitialData(userAddress1InputDispatch, response.data.userInfo.address1);
                    setInitialData(userAddress2InputDispatch, response.data.userInfo.address2);
                    setInitialData(userCityInputDispatch, response.data.userInfo.city);


                    setInitialSelectData(userStateInputDispatch, stateListValues(response.data.demographics, response.data.userInfo.state));
                    setInitialData(userZipInputDispatch, response.data.userInfo.zip);
                    setInitialData(userZipExtInputDispatch, response.data.userInfo.zipext);
                    setInitialData(userPhoneInputDispatch, response.data.userInfo.phoneForDisplay);
                    setInitialData(userPhoneExtInputDispatch, response.data.userInfo.phonextn);
                    setInitialData(userFaxInputDispatch, response.data.userInfo.faxForDisplay);
                    setInitialData(userEmailAddressInputDispatch, response.data.userInfo.emailaddress);
                    setInitialData(userConfirmEmailAddressInputDispatch, response.data.userInfo.confirmemailaddress);
                    //setInitialData(userVertifiedByUserInputDispatch,response.data.userInfo.verifiedByUser);
                }
                else {

                    //dispatch(setStatus(STATUSES.ERROR));
                    //dispatch(setPopup({visible: true, title: ERROR_MESSAGES.DATA_ERROR.title, msg: ERROR_MESSAGES.DATA_ERROR.message, showContactHelp: true }));
                }
            }


            //console.log(response);
            setIsLoading(false);

        }).catch(function (error) {
            //setIsLoading(true);
            //console.log("error caught from loadCompletedPSETestBatches()");
            //console.log(error);
            setGlobalErrorStatus({
                dispatch: dispatch,
                popupData: {
                    visible: true,
                    title: ERROR_MESSAGES.DATA_ERROR.title,
                    msg: ERROR_MESSAGES.DATA_ERROR.message,
                    showContactHelp: true
                },
                redirect: {
                    redirect: true,
                    redirectFirst: false,
                    path: "/",
                    data: { orgType: orgType }
                },
                error: error
            });


            //return Promise.reject({status: status, data: error});
        });
        //res(response);            

        /*//console.log(listValues.stateListValues);
        const orgDetails = res.data.orgDetails;
        const orgStates = listValues.stateListValues(res.data.demographics, orgDetails.regionId);
        const statuses = listValues.orgStatusValues(res.data.organizationStatuses, orgDetails.statusId);
        
 
        return {
            orgStates: orgStates,
            statuses: statuses,
            orgDetails: orgDetails
        }
 
    }).then((obj)=>{
 
        const dets = obj.orgDetails;
 
        const getDateFormat = (value) => {
            if(value != null){
                var split = value.split('/');
                //console.log(split);
                if(split.length==3){
                    return split[2] + '-' + split[0] + '-' + split[1];
                }
                return value;
            }
            return "test";
        }

        const additionalOrganizationInfo= {
            organizationId: dets.organizationId,
            organizationTypeId: dets.organizationTypeId,
        };
 
        return Promise.resolve({status: status, data: additionalOrganizationInfo});
*/
        /*).catch(function (error) {
            //console.log("error caught from loadCompletedPSETestBatches()");
            //console.log(error);
            status = STATUSES.ERROR;;
            return Promise.reject({status: status, data: error});
        });*/


    };

    const initialState = {
        data: '',
        loading: true,
        error: null,
    };



    //const formFieldDisplay = EDIT_ORG_FORM_DISPLAY_DATA(orgType);


    //console.log(formFieldDisplay);

    var orgStatusValues = (fieldData, radioData, selectedValue) => {
        var objArr = [];
        //var radioBtns = fieldData.radioButtons;

        if (radioData != null) {
            for (var i = 0; i < radioData.length; i++) {
                var x = radioData[i];
                objArr.push({
                    id: "orgStatus_" + i,
                    label: x.description,
                    name: "orgStatus",
                    value: x.id,
                    title: "Select status as " + x.description,
                    isChecked: selectedValue == x.id ? true : false,
                    //onChange: handleRadioChange,
                    disabled: fieldData.disabled ? true : false
                });
            }
        }

        //console.log(objArr);
        return objArr;
    };



    var orgTestValues = (fieldData, selectedValue) => {
        var objArr = [];
        var radioBtns = fieldData.radioButtons;

        if (radioBtns != null) {
            for (var i = 0; i < radioBtns.length; i++) {
                var x = radioBtns[i];


                objArr.push({
                    id: fieldData.name + "_" + i,
                    label: x.label,
                    name: fieldData.name,
                    value: x.value,
                    title: x.title,
                    isChecked: selectedValue == x.value ? true : false,//dets.testOrg=="Yes" ? true : false,
                    //onChange: handleRadioChange,
                    disabled: fieldData.disabled ? true : false


                });
            }
        }
        //console.log(objArr);
        return objArr;
    }

    /*
    const prefix = listValues.prefixListValues(res.data.prefixList);
             const suffix = listValues.suffixListValues(res.data.suffixList);
    */

    var stateListValues = (stateList, selectedValue) => {
        //console.log(stateList);
        //console.log(selectedValue);
        var objArr = [];
        objArr.push({
            index: 0,
            value: null,
            title: null,
            displayValue: "Select State",
            isSelected: selectedValue == null ? true : false
        });

        for (var i = 0; i < stateList.length; i++) {
            var x = stateList[i];
            //console.log(x);
            objArr.push({
                index: x.regionId,
                value: x.regionId,
                title: "Select state " + x.name,
                displayValue: x.name,
                isSelected: selectedValue == x.regionId ? true : false
            });
        }

        return objArr;
    };

    var prefixListValues = (prefixList, selectedValue) => {
        var objArr = [];

        objArr.push({
            index: null,
            value: -1,
            title: null,
            displayValue: "",
            isSelected: selectedValue == null ? true : false
        });

        for (var i = 0; i < prefixList.length; i++) {
            var x = prefixList[i];
            objArr.push({
                index: i,
                value: x.prefix,
                title: "Select prefix " + x.prefix,
                displayValue: x.prefix,
                isSelected: selectedValue == x.prefix ? true : false
            });
        }

        return objArr;
    };

    var suffixListValues = (suffixList, selectedValue) => {
        var objArr = [];
        objArr.push({
            index: null,
            value: -1,
            title: null,
            displayValue: "",
            isSelected: selectedValue == null ? true : false
        });

        for (var i = 0; i < suffixList.length; i++) {
            var x = suffixList[i];
            objArr.push({
                index: i,
                value: x.suffix,
                title: "Select suffix " + x.suffix,
                displayValue: x.suffix,
                isSelected: selectedValue == x.suffix ? true : false
            });
        }

        return objArr;
    };

    useEffect(() => {
        getOrgData(orgType, orgId);
        //getTest(orgType,orgId);
        window.scrollTo({ top: 0 });
    }, []);

    const getTest = async (filter) => {

        var call = {
            paginationRequest: filter,
            orgId: orgId
        }
        //console.log("CALL");
        //console.log(call);
        var url = '/api/manage/user/getOrgUsers';
        var status = STATUSES.SUCCESS;
        const loginState = store.getState().loginInfo;
        //const response = PSOORGDATA;
        return http.post(url, call, {
            headers: {
                "Authorization": "Bearer " + loginState.token
                //"Referrer-Policy": "strict-origin-when-cross-origin"
            }
        });
        /*.then((resp)=>{
            if(resp.data!=null){
            }
        });*/
    }



    var [orgName, orgNameInputDispatch] = GetTextInputData('name', '', orgType, 'view');
    var [orgPsoId, orgPsoIdInputDispatch] = GetTextInputData('psoId', '', orgType, 'view');
    var [orgWebsite, orgWebsiteInputDispatch] = GetTextInputData('website', '', orgType, 'view');
    var [orgAddress1, orgAddress1InputDispatch] = GetTextInputData('address1', '', orgType, 'view');
    var [orgAddress2, orgAddress2InputDispatch] = GetTextInputData('address2', '', orgType, 'view');
    var [orgCity, orgCityInputDispatch] = GetTextInputData('city', '', orgType, 'view');
    var [orgState, orgStateInputDispatch] = GetSelectInputData('regionId', '', orgType, 'view');
    var [orgZip, orgZipInputDispatch] = GetTextInputData('zip', '', orgType, 'view');
    var [orgZipExtension, orgZipExtensionInputDispatch] = GetTextInputData('zipExtension', '', orgType, 'view');
    var [orgPhone, orgPhoneInputDispatch] = GetPhoneInputData('phone', '', orgType, 'view');
    var [orgPhoneExtension, orgPhoneExtensionInputDispatch] = GetTextInputData('extension', '', orgType, 'view');
    var [orgFax, orgFaxInputDispatch] = GetPhoneInputData('fax', '', orgType, 'view');
    var [orgStatusId, orgStatusIdInputDispatch] = GetRadioInputData('statusId', '', orgType, 'view');
    var [orgTestOrg, orgTestOrgInputDispatch] = GetRadioInputData('testOrg', '', orgType, 'view');
    var [orgAgreementEffectiveDate, orgAgreementEffectiveDateInputDispatch] = GetDateInputData('agreementEffectiveDate', '', orgType, 'view');
    var [orgListingEffectiveDate, orgListingEffectiveDateInputDispatch] = GetDateInputData('listingEffectiveDate', '', orgType, 'view');
    var [orgAgreementEndDate, orgAgreementEndDateInputDispatch] = GetDateInputData('agreementEndDate', '', orgType, 'view');
    var [orgListingEndDate, orgListingEndDateInputDispatch] = GetDateInputData('listingEndDate', '', orgType, 'view');

    var [userFirstName, userFirstNameInputDispatch] = GetUserTextInputData('firstname', '', orgType, 'view');
    var [userMiddleName, userMiddleNameInputDispatch] = GetUserTextInputData('middlename', '', orgType, 'view');
    var [userLastName, userLastNameInputDispatch] = GetUserTextInputData('lastname', '', orgType, 'view');
    var [userPrefix, userPrefixInputDispatch] = GetUserSelectInputData('prefix', '', orgType, 'view');
    var [userSuffix, userSuffixInputDispatch] = GetUserSelectInputData('suffix', '', orgType, 'view');
    var [userCredentials, userCredentialsInputDispatch] = GetUserTextInputData('credentials', '', orgType, 'view');
    var [userJobTitle, userJobTitleInputDispatch] = GetUserTextInputData('jobTitle', '', orgType, 'view');
    var [userAddress1, userAddress1InputDispatch] = GetUserTextInputData('address1', '', orgType, 'view');
    var [userAddress2, userAddress2InputDispatch] = GetUserTextInputData('address2', '', orgType, 'view');
    var [userCity, userCityInputDispatch] = GetUserTextInputData('city', '', orgType, 'view');
    var [userState, userStateInputDispatch] = GetUserSelectInputData('state', '', orgType, 'view');
    var [userZip, userZipInputDispatch] = GetUserTextInputData('zip', '', orgType, 'view');
    var [userZipExt, userZipExtInputDispatch] = GetUserTextInputData('zipext', '', orgType, 'view');
    var [userPhone, userPhoneInputDispatch] = GetUserPhoneInputData('phoneForDisplay', '', orgType, 'view');
    var [userPhoneExt, userPhoneExtInputDispatch] = GetUserTextInputData('phonextn', '', orgType, 'view');
    var [userFax, userFaxInputDispatch] = GetUserPhoneInputData('faxForDisplay', '', orgType, 'view');
    var [userEmailAddress, userEmailAddressInputDispatch] = GetUserTextInputData('emailaddress', '', orgType, 'view');
    var [userConfirmEmailAddress, userConfirmEmailAddressInputDispatch] = GetUserTextInputData('confirmemailaddress', '', orgType, 'view');
    var [userVertifiedByUser, userVertifiedByUserInputDispatch] = GetUserCheckboxInputData('verifiedByUser', '', orgType, 'view');

    const handleDateFormat = (time) => {
        if (time != null) {
            let date = new Date(time);
            let year = date.getFullYear();
            let month = date.getMonth() + 1;
            let day = date.getDate();
            let hour = date.getHours();
            let min = date.getMinutes();
            return (
                <div>
                    {month < 10 ? "0" + month : month}/
                    {day < 10 ? "0" + day : day}/
                    {year + " "}
                    {hour < 10 ? "0" + hour : hour}:
                    {min < 10 ? "0" + min : min}
                </div>
            )
        }
        else {
            return (
                <div>

                </div>
            )
        }

    }



    const getListCols = (selectedList, sortingInfo) => {
        const listOrganizationColumns = [];

        const title = function ({ rowName }) {
            //TestTitle {0} test {1}
            //Params: rowName, "valuehere"
            return "Click the link to edit user " + rowName + ".";
        }

        const fullNameTitle = function ({ rowName }) {
            //console.log(rowName);
            return "Click the link to view user " + rowName + ".";
        }

        const userState = function ({ rowName }) {
            //console.log(rowName);
            return {
                /*state: {
                    psoId: orgPsoId.value,
                    orgName: orgName.value,
                    orgId: orgId,
                    orgTypeId: orgTypeId,
                    orgType: orgType,
                    backRedirect: {
                        path: "/manage/organization",
                        state: location.state
                    }
                }*/
                userId: rowName.userId,
                statusDesc: rowName.userStatusDesc,
                isPSOPPCAdmin: isPSOPPCAdmin,
                
                backRedirect: {
                    path: location.pathname,
                    state: {
                        ...location.state,
                        filter,
                        psoId: rowName.orgPSOId,
                        id: rowName.orgId,
                        orgType: rowName.orgTypeDesc,
                        orgTypeId: rowName.orgTypeId
                    },

                }
            };

                
        }

        listOrganizationColumns.push(Datatable_Column({ name: "Full Name", columnName: ["firstName", "lastName"], concatColName: "fullName", selectedRows: selectedList, sortable: true, sortFieldNum: 4, isLink: true, linkData: { title: fullNameTitle, pathname: "/manage/viewUser", text: null, state: userState }, sortingInfo: sortingInfo }))
        //listOrganizationColumns.push(Datatable_Column({name:"Last Name", columnName:"lastName", selectedRows: selectedList, sortable:true, sortFieldNum:4}))
        listOrganizationColumns.push(Datatable_Column({ name: "Email Address", columnName: "emailAddress", selectedRows: selectedList, sortable: true, sortFieldNum: 4, sortingInfo: sortingInfo }))
        listOrganizationColumns.push(Datatable_Column({ name: "Organization", columnName: "psoName", selectedRows: selectedList, sortable: true, sortFieldNum: 4, sortingInfo: sortingInfo }))
        listOrganizationColumns.push(Datatable_Column({ name: "User Status", columnName: "userStatusDesc", selectedRows: selectedList, sortable: true, sortFieldNum: 4, sortingInfo: sortingInfo }))
        listOrganizationColumns.push(Datatable_Column({ name: "Role", columnName: "roleName", selectedRows: selectedList, sortable: true, sortFieldNum: 4, sortingInfo: sortingInfo }))
        listOrganizationColumns.push(Datatable_Column({ name: "Last Sign In", columnName: "loginDate", selectedRows: selectedList, sortable: true, sortFieldNum: 4, formatFunction: handleDateFormat, sortingInfo: sortingInfo }))
        listOrganizationColumns.push(Datatable_Column({ name: "Edit", columnName: "edit", selectedRows: selectedList, sortable: false, sortFieldNum: 4, isLink: true, linkData: { title: title, pathname: "/manage/editUser", text: "Edit", state: userState }, sortingInfo: sortingInfo }))

        return listOrganizationColumns;
    }

    var getTableTitle = () => {
        if (orgType == "Vendor") {
            return "Manage Vendor User";
        }
        else if (orgType == "PSO") {
            return "Manage PSO User"
        }
        else {
            return "Manage Organization User"
        }
    }


    
    const [backRedirect, setBackRedirect] = useState(passedData.backRedirect);

    const handleBack = async () => {
        //console.log("BACK");
        //console.log(backRedirect);
        //navigate(-1);
        //redirectDocument("/manage/user");
        if (backRedirect.path == null) {
            setBackRedirect("/manage/organization");
        }
        navigate(
            backRedirect.hasOwnProperty("path") && backRedirect.path == null != null ? backRedirect.path : "/manage/organization",
            { state: backRedirect.state }
        );
    };

    const [selectedCount, setSelectedCount] = useState(0);


    const handleCreateUser = (e) => {


        //console.log("HANDLE CREATE USER", e);

        navigate(
            "/manage/createUser",
            {
                state: {
                    psoId: orgPsoId.value,
                    orgName: orgName.value,
                    orgId: orgId,
                    orgTypeId: orgTypeId,
                    orgType: orgType,
                    backRedirect: {
                        path: "/manage/organization",
                        state: location.state
                    }
                }
            }
        );


    }

    const horizForm = { is: true, labelCols: { lg: 3, md: 4 }, inputCols: { lg: 5 } };

    return (
        <Row>

            {

                isLoading || orgType==null?
                    null
                    :
                    <Row >
                        <Col xl={11} lg={11} md={11} sm={12}>
                            <Card className="p-4">
                                <Card.Body className="text-start">

                                    <Row>
                                        <h1 id="mainContent" className="header1 text-start mb-3 blue bold">
                                            {"View " + orgType + " Organization"}
                                        </h1>

                                    </Row>
                                    <Row className="mb-5">

                                        <Form>
                                            <h2>Organization Information</h2>
                                            <FormInputDisplay fieldData={orgName} inputDispatch={orgNameInputDispatch} orgType={orgType} isHorizontal={true} hideLabel={false} horizontalForm={horizForm}></FormInputDisplay>
                                            <FormInputDisplay fieldData={orgPsoId} inputDispatch={orgPsoIdInputDispatch} orgType={orgType} isHorizontal={true} hideLabel={false} horizontalForm={horizForm}></FormInputDisplay>
                                            <FormInputDisplay fieldData={orgWebsite} inputDispatch={orgWebsiteInputDispatch} orgType={orgType} isHorizontal={true} hideLabel={false} horizontalForm={horizForm}></FormInputDisplay>
                                            <FormInputDisplay fieldData={orgAddress1} inputDispatch={orgAddress1InputDispatch} orgType={orgType} isHorizontal={true} hideLabel={false} horizontalForm={horizForm}></FormInputDisplay>
                                            <FormInputDisplay fieldData={orgAddress2} inputDispatch={orgAddress2InputDispatch} orgType={orgType} isHorizontal={true} hideLabel={false} horizontalForm={horizForm}></FormInputDisplay>
                                            <FormInputDisplay fieldData={orgCity} inputDispatch={orgCityInputDispatch} orgType={orgType} isHorizontal={true} hideLabel={false} horizontalForm={horizForm}></FormInputDisplay>
                                            <FormInputDisplay fieldData={orgState} inputDispatch={orgStateInputDispatch} orgType={orgType} isHorizontal={true} hideLabel={false} horizontalForm={horizForm}></FormInputDisplay>
                                            <FormInputDisplay fieldData={orgZip} inputDispatch={orgZipInputDispatch} orgType={orgType} isHorizontal={true} hideLabel={false} horizontalForm={horizForm}></FormInputDisplay>
                                            <FormInputDisplay fieldData={orgZipExtension} inputDispatch={orgZipExtensionInputDispatch} orgType={orgType} isHorizontal={true} hideLabel={false} horizontalForm={horizForm}></FormInputDisplay>
                                            <FormInputDisplay fieldData={orgPhone} inputDispatch={orgPhoneInputDispatch} orgType={orgType} isHorizontal={true} hideLabel={false} horizontalForm={horizForm}></FormInputDisplay>
                                            <FormInputDisplay fieldData={orgPhoneExtension} inputDispatch={orgPhoneExtensionInputDispatch} orgType={orgType} isHorizontal={true} hideLabel={false} horizontalForm={horizForm}></FormInputDisplay>
                                            <FormInputDisplay fieldData={orgFax} inputDispatch={orgFaxInputDispatch} orgType={orgType} isHorizontal={true} hideLabel={false} horizontalForm={horizForm}></FormInputDisplay>
                                            <FormInputDisplay fieldData={orgStatusId} inputDispatch={orgStatusIdInputDispatch} orgType={orgType} isHorizontal={true} hideLabel={false} horizontalForm={horizForm}></FormInputDisplay>

                                            {orgType == "PSO" || orgType == "Vendor"
                                                ? <FormInputDisplay fieldData={orgTestOrg} inputDispatch={orgTestOrgInputDispatch} orgType={orgType} isHorizontal={true} hideLabel={false} horizontalForm={horizForm}></FormInputDisplay>
                                                : null
                                            }

                                            {orgType == "PSO" || orgPsoId == null
                                                ? <>
                                                    <h3>Data Submission and Use Agreement</h3>
                                                    <FormInputDisplay fieldData={orgAgreementEffectiveDate} inputDispatch={orgAgreementEffectiveDateInputDispatch} orgType={orgType} isHorizontal={true} hideLabel={false} horizontalForm={horizForm}></FormInputDisplay>
                                                    <FormInputDisplay fieldData={orgAgreementEndDate} inputDispatch={orgAgreementEndDateInputDispatch} orgType={orgType} isHorizontal={true} hideLabel={false} horizontalForm={horizForm}></FormInputDisplay>

                                                    <h3>Listing Date</h3>
                                                    <FormInputDisplay fieldData={orgListingEffectiveDate} inputDispatch={orgListingEffectiveDateInputDispatch} orgType={orgType} isHorizontal={true} hideLabel={false} horizontalForm={horizForm}></FormInputDisplay>
                                                    <FormInputDisplay fieldData={orgListingEndDate} inputDispatch={orgListingEndDateInputDispatch} orgType={orgType} isHorizontal={true} hideLabel={false} horizontalForm={horizForm}></FormInputDisplay>

                                                </>

                                                : null
                                            }

                                            {orgType == "PSO"
                                                ?
                                                <>
                                                    {orgType == "PSO"
                                                        ? <h2>AHRQ Certified Contact Information</h2>
                                                        : ""
                                                    }
                                                    {orgType == "Vendor"
                                                        ? <h2>Vendor Certified Contact Information</h2>
                                                        : ""
                                                    }


                                                    <FormInputDisplay fieldData={userFirstName} inputDispatch={userFirstNameInputDispatch} orgType={orgType} isHorizontal={true} hideLabel={false} horizontalForm={horizForm}></FormInputDisplay>
                                                    <FormInputDisplay fieldData={userMiddleName} inputDispatch={userMiddleNameInputDispatch} orgType={orgType} isHorizontal={true} hideLabel={false} horizontalForm={horizForm}></FormInputDisplay>
                                                    <FormInputDisplay fieldData={userLastName} inputDispatch={userLastNameInputDispatch} orgType={orgType} isHorizontal={true} hideLabel={false} horizontalForm={horizForm}></FormInputDisplay>
                                                    <FormInputDisplay fieldData={userPrefix} inputDispatch={userPrefixInputDispatch} orgType={orgType} isHorizontal={true} hideLabel={false} horizontalForm={horizForm}></FormInputDisplay>
                                                    <FormInputDisplay fieldData={userSuffix} inputDispatch={userSuffixInputDispatch} orgType={orgType} isHorizontal={true} hideLabel={false} horizontalForm={horizForm}></FormInputDisplay>
                                                    <FormInputDisplay fieldData={userCredentials} inputDispatch={userCredentialsInputDispatch} orgType={orgType} isHorizontal={true} hideLabel={false} horizontalForm={horizForm}></FormInputDisplay>
                                                    <FormInputDisplay fieldData={userJobTitle} inputDispatch={userJobTitleInputDispatch} orgType={orgType} isHorizontal={true} hideLabel={false} horizontalForm={horizForm}></FormInputDisplay>
                                                    <FormInputDisplay fieldData={userAddress1} inputDispatch={userAddress1InputDispatch} orgType={orgType} isHorizontal={true} hideLabel={false} horizontalForm={horizForm}></FormInputDisplay>
                                                    <FormInputDisplay fieldData={userAddress2} inputDispatch={userAddress2InputDispatch} orgType={orgType} isHorizontal={true} hideLabel={false} horizontalForm={horizForm}></FormInputDisplay>
                                                    <FormInputDisplay fieldData={userCity} inputDispatch={userCityInputDispatch} orgType={orgType} isHorizontal={true} hideLabel={false} horizontalForm={horizForm}></FormInputDisplay>
                                                    <FormInputDisplay fieldData={userState} inputDispatch={userStateInputDispatch} orgType={orgType} isHorizontal={true} hideLabel={false} horizontalForm={horizForm}></FormInputDisplay>
                                                    <FormInputDisplay fieldData={userZip} inputDispatch={userZipInputDispatch} orgType={orgType} isHorizontal={true} hideLabel={false} horizontalForm={horizForm}></FormInputDisplay>
                                                    <FormInputDisplay fieldData={userZipExt} inputDispatch={userZipExtInputDispatch} orgType={orgType} isHorizontal={true} hideLabel={false} horizontalForm={horizForm}></FormInputDisplay>
                                                    <FormInputDisplay fieldData={userPhone} inputDispatch={userPhoneInputDispatch} orgType={orgType} isHorizontal={true} hideLabel={false} horizontalForm={horizForm}></FormInputDisplay>
                                                    <FormInputDisplay fieldData={userPhoneExt} inputDispatch={userPhoneExtInputDispatch} orgType={orgType} isHorizontal={true} hideLabel={false} horizontalForm={horizForm}></FormInputDisplay>
                                                    <FormInputDisplay fieldData={userFax} inputDispatch={userFaxInputDispatch} orgType={orgType} isHorizontal={true} hideLabel={false} horizontalForm={horizForm}></FormInputDisplay>
                                                    <FormInputDisplay fieldData={userEmailAddress} inputDispatch={userEmailAddressInputDispatch} orgType={orgType} isHorizontal={true} hideLabel={false} horizontalForm={horizForm}></FormInputDisplay>
                                                    <FormInputDisplay fieldData={userConfirmEmailAddress} inputDispatch={userConfirmEmailAddressInputDispatch} orgType={orgType} isHorizontal={true} hideLabel={false} horizontalForm={horizForm}></FormInputDisplay>
                                                </>
                                                : null
                                            }


                                            {/*
                                            <c:if test="${isPSOPPCAdmin}">
                                                <div class="dashboardTableStyle">
                                            
                                                <h2 tabindex="0" style="text-align:center;">
                                                <c:choose>
                                                    <c:when test="${organizationDetails.organizationTypeId == 26}"> Manage Vendor User&nbsp;&nbsp;</c:when>
                                                    <c:when test="${organizationDetails.organizationTypeId == 24}"> Manage PSO User&nbsp;&nbsp;</c:when>
                                                    <c:otherwise>Manage Organization User&nbsp;&nbsp;</c:otherwise>
                                                </c:choose>
                                                </h2>
                                            
                                                <p tabindex="0" style="margin-top:-2px; font-weight:normal;text-align:center;">Select a user to view detailed information.</p>
                                                
                                                <div style="margin-right: 0px; margin-bottom:10px;">
                                                    <c:if test="${allow_user_edit}">
                                                        <input tabindex="0" type="submit" class="dashboard"  onClick="javascript:submit3(${organizationDetails.organizationId})" style="margin-left:0px;" value="Create a New User" />&nbsp;&nbsp;
                                                        <div class="clear"></div>
                                                    </c:if>
                                                </div>
                                                            
                                                    <div class="formTable">
                                                    
                                                    <table id="userList" width="100%" Summary="This table contains list of the users in an organization.">
                                                            <thead>
                                                                <tr>
                                                                    <th id="orgUserName">Full Name</th>
                                                                    <th id="orgUserEmail">Email Address</th>
                                                                    <th id="orgUserOrg">Organization</th>
                                                                    <th id="orgUserStatus">User Status</th>
                                                                    <th id="role">Role</th>
                                                                    <th id="orgUserLastSignIn">Last Sign In</th>
                                                                    <th id="orgUserEdit">Edit</th>
                                                                </tr>
                                                            </thead>
                                                            <tbody>
                                                            </tbody>
                                                        </table>
                                                    
                                                    </div>
                                                </div>
                                            </c:if>
                                            
                                            <div class="row right" id="actionButton">
                                                <input  tabindex="0" title="Click on Back to go back to the Manage ${orgType} Organization page" type="button" name="Back" value="Back" class="cancel" onclick="window.location='${context}/manage/${orgType}'; return false;" />
                                            </div>
                                        */}







                                        </Form>
                                    </Row>

                                    {filter != null
                                        ? <DatatableBase
                                            tableClassName="viewOrgUserTable"

                                            filter={filter}
                                            setFilter={setFilter}

                                            getData={getTest}
                                            getListCols={getListCols}
                                            setSelectedCount={setSelectedCount}
                                            hasSelectableRows={false}
                                            searchFieldText={"Search by name, email, organization, status and role"}
                                            datatableHeader={getTableTitle()}
                                            datatableDescription={"Select a user to view detailed information."}
                                            sortingColumn={viewUsersSortColumn.sortField}
                                            sortingOrder={viewUsersSortColumn.sortDirection}
                                        >
                                            {allowUserEdit == true && isLoading == false
                                                ? <Col className="d-flex justify-content-end ">
                                                    <TextButton className="ms-auto " onClick={handleCreateUser} variant="normal" content={"Create a New User"} />
                                                </Col>
                                                : null
                                            }
                                        </DatatableBase>
                                        : null
                                    }

                                    <Stack direction="horizontal" gap={3} className="mt-4">
                                        {/* Back Button */}
                                        <TextButton
                                            variant="outline"
                                            onClick={handleBack}
                                            content={"Back"}
                                            className="ms-auto"
                                        >
                                        </TextButton>
                                    </Stack>
                                </Card.Body>
                            </Card>
                        </Col>
                    </Row>
            }

        </Row>
    );
}



export default ViewOrganization